import React from 'react'
import './MetricsDisplay.css'

const LANG_META = {
  sv: { label: 'Swedish', color: '#006aa7' },
  no: { label: 'Norwegian', color: '#ba0c2f' },
  en: { label: 'English', color: '#00247d' }
}

/**
 * Displays a set of chat‑quality metrics.
 * Each card shows the **count** and the **percentage** of the total.
 *
 * Expected `metrics` shape (from /analyze_external_v2):
 * {
 *   total_count: number,
 *   positive_count: number,
 *   negative_count: number,
 *   had_rag_count: number,
 *   had_approval_count: number,
 *   had_error_count: number,
 *   languages: { sv: number, en: number, no: number, ... }
 * }
 */
const MetricsDisplay = ({ metrics }) => {
  if (!metrics) return null

  const {
    total_count,
    positive_count,
    negative_count,
    languages
  } = metrics

  // Helper: safe percentage
  const pct = (count) => (total_count > 0 ? (count / total_count) * 100 : 0)

  const metricsToDisplay = [
    {
      title: 'Total Messages',
      count: total_count,
      percentage: 100,
      color: '#000000'
    },
    {
      title: 'Positive Feedback',
      count: positive_count,
      percentage: pct(positive_count),
      color: '#2ecc71'
    },
    {
      title: 'Negative Feedback',
      count: negative_count,
      percentage: pct(negative_count),
      color: '#e74c3c'
    }
  ]

  // Add language cards dynamically from the languages dict
  if (languages && typeof languages === 'object') {
    for (const [code, count] of Object.entries(languages)) {
      const meta = LANG_META[code] || { label: code.toUpperCase(), color: '#7f8c8d' }
      metricsToDisplay.push({
        title: meta.label,
        count: count,
        percentage: pct(count),
        color: meta.color
      })
    }
  }

  return (
    <div className="metrics-container">
      {metricsToDisplay.map(({ title, count, percentage, color }, i) => (
        <div className="metric-card" key={i}>
          {/* Label */}
          <div className="metric-title">{title}</div>

          {/* Main number */}
          <div className="metric-number" style={{ color }}>
            {count}
          </div>

          {/* Percentage below */}
          <div className="metric-percentage">{percentage.toFixed(1)}%</div>
        </div>
      ))}
    </div>
  )
}

export default MetricsDisplay
